import { render, staticRenderFns } from "./closed.vue?vue&type=template&id=de04aa16&scoped=true&"
import script from "./closed.vue?vue&type=script&lang=js&"
export * from "./closed.vue?vue&type=script&lang=js&"
import style0 from "./closed.vue?vue&type=style&index=0&id=de04aa16&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de04aa16",
  null
  
)

export default component.exports